<div class="container">

  <app-header-dialog [iconName]="'mail_outline'">
    Preview
  </app-header-dialog>

  <div class='content'>

    <div [innerHTML]='letter_preview' style='width: 800px; padding:30px;'>
    </div>

  </div>

</div>